import { createRafContentScheduler } from './rafContentScheduler';

export type DocumentStreamDetail = {
  tabId?: string;
  html?: string;
};

export function dispatchDocumentStreamStart(tabId?: string): void {
  window.dispatchEvent(
    new CustomEvent<DocumentStreamDetail>('lexcounsel-document-stream-start', {
      detail: { tabId },
    }),
  );
}

export function dispatchDocumentStreamFinal(tabId: string | undefined, html: string): void {
  window.dispatchEvent(
    new CustomEvent<DocumentStreamDetail>('lexcounsel-document-stream-final', {
      detail: { tabId, html },
    }),
  );
}

export function dispatchDocumentStreamCancel(tabId?: string): void {
  window.dispatchEvent(
    new CustomEvent<DocumentStreamDetail>('lexcounsel-document-stream-cancel', {
      detail: { tabId },
    }),
  );
}

export function createDocumentStreamDeltaScheduler(tabId?: string) {
  return createRafContentScheduler((html) => {
    window.dispatchEvent(
      new CustomEvent<DocumentStreamDetail>('lexcounsel-document-stream-delta', {
        detail: { tabId, html },
      }),
    );
  });
}
